// v3.4.060 — إدارة حسابات البوابة الخارجية — صفحة مستقلة تحت «تطبيق المنظم التسويقي»
// كانت تابًا داخل «العملاء المحتملون»؛ نُقلت لأن الحسابات تخصّ التطبيق نفسه لا قائمة العملاء.
import React, { useState, useEffect } from "react";
import { ref as refApi } from "../services/api";
import { useAuth } from "../context/AuthContext";
import { PortalAccountsModal } from "./ClientProspectsPage";
import { FiKey } from "react-icons/fi";

export default function PortalAccountsPage() {
  const { user } = useAuth();
  const [marketers, setMarketers] = useState([]);
  const canManage = (user?.role === "admin" && !user?.impersonating) || user?.can_manage_users || user?.cp_can_manage_accounts;

  useEffect(() => {
    refApi.getMarketers().then(r => {
      const d = r.data;
      setMarketers(Array.isArray(d) ? d : (Array.isArray(d?.items) ? d.items : (Array.isArray(d?.marketers) ? d.marketers : [])));
    }).catch(() => {});
  }, []);

  if (!canManage) {
    return <div style={{ padding: 40, textAlign: "center", color: "#b45309", fontSize: 14 }}>ليس لديك صلاحية إدارة حسابات البوابة</div>;
  }

  return (
    <div style={{ padding: "20px 24px", direction: "rtl" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
        <FiKey size={20} style={{ color: "#0f766e" }} />
        <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: "#0f172a" }}>إدارة حسابات البوابة</h2>
      </div>
      <PortalAccountsModal marketers={marketers} inline onClose={() => {}} />
    </div>
  );
}
